import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { collectEmail } from '../lib/api';
import { getUserEmail, setUserEmail } from '../lib/utils';
import { toast } from 'sonner';

const EmailModal = ({ isOpen, onClose }) => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!email) return;

        setLoading(true);
        try {
            await collectEmail(email);
            setUserEmail(email);
            toast.success('Welcome to Hotel Motel Club!');
            onClose();
        } catch (error) {
            toast.error('Something went wrong. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="modal-overlay" data-testid="email-modal">
            <div className="modal-content animate-fadeIn">
                <div className="flex justify-between items-start mb-4">
                    <div>
                        <h2 className="font-heading text-2xl font-bold text-navy">Welcome to Hotel Motel Club</h2>
                        <p className="text-gray-600 mt-1">Enter your email to access all listings</p>
                    </div>
                    <button onClick={onClose} className="p-1 hover:bg-gray-100 rounded" data-testid="close-modal-btn">
                        <X className="w-5 h-5" />
                    </button>
                </div>

                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <Input
                            type="email"
                            placeholder="Enter your email address"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            className="w-full"
                            data-testid="email-input"
                        />
                    </div>
                    <Button
                        type="submit"
                        className="w-full bg-gold hover:bg-amber-600"
                        disabled={loading}
                        data-testid="submit-email-btn"
                    >
                        {loading ? 'Please wait...' : 'Continue Browsing'}
                    </Button>
                </form>

                <p className="text-xs text-gray-500 mt-4 text-center">
                    By continuing, you agree to receive marketing communications from Hotel Motel Club.
                </p>
            </div>
        </div>
    );
};

export default EmailModal;
